import Vue from 'vue'
import { cloneDeep, kebabCase, set, filter, get, map } from 'lodash'

import { USER_ACTIVITY_TARGET_TYPE } from '../utils/const'
import { GET_USER_ACTIVITY_HISTORIES } from '../graphql/queries/users'
import { generateRandomId } from '~/utils/helper/commonFunction'
import {
  GET_APPRAISAL_STANDARDS,
  GET_SCHOOL_APPRAISAL_RECORDS_ASSIGN,
  GET_APPRAISAL_SUMMARY,
  GET_APPRAISAL_PERIODS,
  GET_ACTIVATED_FRAMEWORKS,
  GET_APPRAISAL_FRAMEWORK_DETAIL,
} from '~/graphql/queries/performance'
import { GET_APPRAISAL_REVIEW_PROCESS } from '~/graphql/queries/academySchedule.js'
import {
  APPRAISAL_CREATE_FRAMEWORK,
  APPRAISAL_UPDATE_FRAMEWORK,
  APPRAISAL_DUPLICATE_FRAMEWORK,
  APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD,
} from '~/graphql/mutations/performance'

import { getAppraisalStandardsImage } from '~/global/data/performance'
import { getListFrameworksV2 } from '~/api/performance'

const mutationTypes = {
  SET_FETCHING_APPRAISAL_STANDARDS: 'SET_FETCHING_APPRAISAL_STANDARDS',
  SET_FETCH_ERROR_APPRAISAL_STANDARDS: 'SET_FETCH_ERROR_APPRAISAL_STANDARDS',
  SET_LIST_APPRAISAL_STANDARDS: 'SET_LIST_APPRAISAL_STANDARDS',
  UPDATE_LIST_APPRAISAL_STANDARDS: 'UPDATE_LIST_APPRAISAL_STANDARDS',
  SWITCH_VIEWING_MODE: 'SWITCH_VIEWING_MODE',

  SET_FETCHING_APPRAISAL_ASSIGNS: 'SET_FETCHING_APPRAISAL_ASSIGNS',
  SET_FETCH_ERROR_APPRAISAL_ASSIGNS: 'SET_FETCH_ERROR_APPRAISAL_ASSIGNS',
  SET_LIST_APPRAISAL_ASSIGNS: 'SET_LIST_APPRAISAL_ASSIGNS',
  UPDATE_LIST_APPRAISAL_ASSIGNS: 'UPDATE_LIST_APPRAISAL_ASSIGNS',

  SET_FETCHING_APPRAISAL_FRAMEWORKS: 'SET_FETCHING_APPRAISAL_FRAMEWORKS',
  SET_FETCH_ERROR_APPRAISAL_FRAMEWORKS: 'SET_FETCH_ERROR_APPRAISAL_FRAMEWORKS',
  SET_LIST_APPRAISAL_FRAMEWORKS: 'SET_LIST_APPRAISAL_FRAMEWORKS',
  SET_LIST_ACTIVATED_INTERNATIONAL_FRAMEWORKS: 'SET_LIST_ACTIVATED_INTERNATIONAL_FRAMEWORKS',

  SET_FETCHING_APPRAISAL_AUDITS: 'SET_FETCHING_APPRAISAL_AUDITS',
  SET_FETCH_ERROR_APPRAISAL_AUDITS: 'SET_FETCH_ERROR_APPRAISAL_AUDITS',
  SET_LIST_APPRAISAL_AUDITS: 'SET_LIST_APPRAISAL_AUDITS',
  SET_APPRAISAL_SUMMARY: 'SET_APPRAISAL_SUMMARY',
  SET_APPRAISAL_PERIODS: 'SET_APPRAISAL_PERIODS',
  SET_EDITTING_APPRAISAL_FRAMEWORK: 'SET_EDITTING_APPRAISAL_FRAMEWORK',
  SET_CREATING_NEW_FRAMEWORK: 'SET_CREATING_NEW_FRAMEWORK',
  SET_UPDATING_FRAMEWORK: 'SET_UPDATING_FRAMEWORK',
  SET_DUPLICATING_FRAMEWORK: 'SET_DUPLICATING_FRAMEWORK',

  SET_APPRAISAL_FRAMEWORK_DETAIL: 'SET_APPRAISAL_FRAMEWORK_DETAIL',
  SET_FETCHING_APPRAISAL_FRAMEWORK_DETAIL: 'SET_FETCHING_APPRAISAL_FRAMEWORK_DETAIL',
  SET_FRAMEWORK_INFOCUS: 'SET_FRAMEWORK_INFOCUS',
  SET_FRAMEWORK_INFOCUS_OBJECT: 'SET_FRAMEWORK_INFOCUS_OBJECT',

  SET_REVIEW_PROCESS_SETTING: 'SET_REVIEW_PROCESS_SETTING',
  SET_REVIEW_PROCESS_ACTIVITIES: 'SET_REVIEW_PROCESS_ACTIVITIES',
  SET_IS_PERFORMANCE_V2: 'SET_IS_PERFORMANCE_V2',
}

const actionTypes = {
  FETCH_APPRAISAL_STANDARDS: 'FETCH_APPRAISAL_STANDARDS',
  FETCH_APPRAISAL_ASSIGNS: 'FETCH_APPRAISAL_ASSIGNS',
  FETCH_APPRAISAL_FRAMEWORKS: 'FETCH_APPRAISAL_FRAMEWORKS',
  FETCH_ACTIVATED_FRAMEWORKS: 'FETCH_ACTIVATED_FRAMEWORKS',
  FETCH_APPRAISAL_SUMMARY: 'FETCH_APPRAISAL_SUMMARY',
  FETCH_APPRAISAL_PERIODS: 'FETCH_APPRAISAL_PERIODS',
  CREATE_NEW_FRAMEWORK: 'CREATE_NEW_FRAMEWORK',
  UPDATE_FRAMEWORK: 'UPDATE_FRAMEWORK',
  FETCH_APPRAISAL_FRAMEWORK_DETAIL: 'FETCH_APPRAISAL_FRAMEWORK_DETAIL',
  FETCH_APPRAISAL_REVIEW_PROCESS: 'FETCH_APPRAISAL_REVIEW_PROCESS',
  FETCH_APPRAISAL_ASSIGN_AUDITS: 'FETCH_APPRAISAL_ASSIGN_AUDITS',
  APPRAISAL_DUPLICATE_FRAMEWORK: 'APPRAISAL_DUPLICATE_FRAMEWORK',
  APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD: 'APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD',
  FETCH_REVIEW_PROCESS_ACTIVITIES: 'FETCH_REVIEW_PROCESS_ACTIVITIES',
  CHECK_IS_PERFORMANCE_V2: 'CHECK_IS_PERFORMANCE_V2',
}

const NEW_FRAMEWORK_SAMPLE = {
  appraisalTypes: [
    {
      id: generateRandomId('layer-1'),
      name: 'New Track',
      appraisals: [
        {
          id: generateRandomId('layer-2'),
          name: 'New Role',
          order: 0,
          appraisalFields: [
            {
              // id: generateRandomId('layer-3'),
              name: 'New Section',
              order: 0,
              children: [
                {
                  // id: generateRandomId('layer-4'),
                  name: 'Sub Item 1',
                  order: 0,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

const excludeFields = (obj, keyToRemove) => {
  map(obj, (field) => {
    if (field[keyToRemove]) {
      delete field[keyToRemove]
    }
    if (field.children) {
      excludeFields(field.children, keyToRemove)
    }
    if (field.appraisals) {
      excludeFields(field.appraisals, keyToRemove)
    }
    if (field.appraisalFields) {
      excludeFields(field.appraisalFields, keyToRemove)
    }
  })
  return obj
}

export const state = () => ({
  appraisalStandards: {
    fetching: false,
    error: false,
    list: [],
  },
  schoolAppraisalAssigns: {
    fetching: false,
    error: false,
    list: [],
  },
  appraisalFrameworks: {
    fetching: false,
    error: false,
    list: [],
  },
  appraisalAudits: {
    fetching: false,
    error: false,
    list: [],
  },
  appraisalPeriods: [],
  activatedInternationalFrameworks: [],
  viewingMode: 'user',
  appraisalFrameworkDetails: {},
  frameworkInFocus: NEW_FRAMEWORK_SAMPLE,
  createNewFramework: {
    success: null,
    inProgress: false,
  },
  updateFramework: {
    success: null,
    inProgress: false,
  },
  duplicatingFramework: {
    success: null,
    inProgress: false,
  },
  fetchFrameworkDetail: {
    success: null,
    inProgress: true,
  },
  reviewProcessSettings: {},
  reviewProcessActivities: {
    data: [],
    meta: {
      limit: 5,
      total: 0,
      page: 1,
    },
    loading: false,
  },
  isPerformanceV2: false,
})

export const mutations = {
  [mutationTypes.SET_FETCHING_APPRAISAL_STANDARDS](state, fetching) {
    state.appraisalStandards.fetching = fetching
  },
  [mutationTypes.SET_FETCH_ERROR_APPRAISAL_STANDARDS](state, error) {
    state.appraisalStandards.error = error
  },
  [mutationTypes.SET_LIST_APPRAISAL_STANDARDS](state, list) {
    state.appraisalStandards.list = list
  },
  [mutationTypes.SWITCH_VIEWING_MODE](state) {
    state.viewingMode = state.viewingMode === 'user' ? 'admin' : 'user'
  },

  [mutationTypes.SET_FETCHING_APPRAISAL_ASSIGNS](state, fetching) {
    state.schoolAppraisalAssigns.fetching = fetching
  },
  [mutationTypes.SET_FETCH_ERROR_APPRAISAL_ASSIGNS](state, error) {
    state.schoolAppraisalAssigns.error = error
  },
  [mutationTypes.SET_LIST_APPRAISAL_ASSIGNS](state, list) {
    state.schoolAppraisalAssigns.list = list
  },
  [mutationTypes.SET_LIST_ACTIVATED_INTERNATIONAL_FRAMEWORKS](state, list) {
    state.activatedInternationalFrameworks = list
  },
  [mutationTypes.UPDATE_LIST_APPRAISAL_ASSIGNS](state, appraisalAssign) {
    const index = state.schoolAppraisalAssigns.list.findIndex((item) => item.id === appraisalAssign.id)
    if (index > -1) {
      Vue.set(state.schoolAppraisalAssigns.list, index, appraisalAssign)
    }
  },

  [mutationTypes.SET_FETCHING_APPRAISAL_FRAMEWORKS](state, fetching) {
    state.appraisalFrameworks.fetching = fetching
  },
  [mutationTypes.SET_FETCH_ERROR_APPRAISAL_FRAMEWORKS](state, error) {
    state.appraisalFrameworks.error = error
  },
  [mutationTypes.SET_LIST_APPRAISAL_FRAMEWORKS](state, list) {
    state.appraisalFrameworks.list = list
  },

  [mutationTypes.SET_FETCHING_APPRAISAL_AUDITS](state, fetching) {
    state.schoolAppraisalAudits.fetching = fetching
  },
  [mutationTypes.SET_FETCH_ERROR_APPRAISAL_AUDITS](state, error) {
    state.schoolAppraisalAudits.error = error
  },
  [mutationTypes.SET_LIST_APPRAISAL_AUDITS](state, list) {
    state.schoolAppraisalAudits.list = list
  },
  [mutationTypes.SET_APPRAISAL_PERIODS](state, periods) {
    state.appraisalPeriods = periods
  },
  [mutationTypes.SET_EDITTING_APPRAISAL_FRAMEWORK](state, { fieldPath, value }) {
    const updatedFramework = cloneDeep(state.frameworkInFocus)
    set(updatedFramework, fieldPath, value)
    state.frameworkInFocus = updatedFramework
  },
  [mutationTypes.SET_CREATING_NEW_FRAMEWORK](state, inProgress) {
    state.createNewFramework = {
      ...state.createNewFramework,
      inProgress,
    }
  },
  [mutationTypes.SET_UPDATING_FRAMEWORK](state, inProgress) {
    state.updateFramework = {
      ...state.updateFramework,
      inProgress,
    }
  },
  [mutationTypes.SET_DUPLICATING_FRAMEWORK](state, inProgress) {
    state.duplicatingFramework = {
      ...state.duplicatingFramework,
      inProgress,
    }
  },
  [mutationTypes.SET_FETCHING_APPRAISAL_FRAMEWORK_DETAIL](state, inProgress) {
    state.fetchFrameworkDetail = {
      inProgress,
    }
  },
  [mutationTypes.SET_APPRAISAL_FRAMEWORK_DETAIL](state, appraisalFramework) {
    const appraisalTypes = {}
    const appraisalTypesArr = []
    map(appraisalFramework.appraisals, (appraisal) => {
      const { type } = appraisal
      if (!appraisalTypes[type]) {
        appraisalTypes[type] = {
          name: type,
          appraisals: [],
        }
      }
      appraisalTypes[type].appraisals.push(appraisal)
    })
    map(appraisalTypes, (appraisalTrack) => {
      appraisalTypesArr.push(appraisalTrack)
    })

    const transformedFramework = {
      ...appraisalFramework,
      appraisalTypes: excludeFields(appraisalTypesArr, 'id'),
    }

    state.appraisalFrameworkDetails = {
      ...state.appraisalFrameworkDetails,
      [appraisalFramework.id]: transformedFramework,
    }

    state.frameworkInFocus = transformedFramework
  },
  [mutationTypes.SET_FRAMEWORK_INFOCUS](state, id) {
    if (!id) {
      state.frameworkInFocus = NEW_FRAMEWORK_SAMPLE
    } else {
      state.frameworkInFocus = get(
        filter(state.appraisalFrameworkDetails, (framework) => parseInt(framework.id) === parseInt(id)),
        '0',
        null
      )
    }
  },
  [mutationTypes.SET_FRAMEWORK_INFOCUS_OBJECT](state, framework) {
    state.frameworkInFocus = framework
  },
  [mutationTypes.SET_REVIEW_PROCESS_SETTING](state, payload) {
    state.reviewProcessSettings = payload
  },
  [mutationTypes.SET_REVIEW_PROCESS_ACTIVITIES](state, payload) {
    state.reviewProcessActivities = payload
  },
  [mutationTypes.SET_IS_PERFORMANCE_V2](state, payload) {
    state.isPerformanceV2 = payload
  },
}

export const actions = {
  async [actionTypes.FETCH_APPRAISAL_REVIEW_PROCESS]({ state, commit, rootState }) {
    try {
      const schoolId = get(rootState, 'school.schoolProfile.id', null)
      if (!schoolId || get(state, 'reviewProcessSettings.schoolId', null)) return
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_APPRAISAL_REVIEW_PROCESS,
        variables: { schoolId },
      })
      if (data) {
        commit(mutationTypes.SET_REVIEW_PROCESS_SETTING, data.appraisalReviewProcess || {})
        return
      }
      throw data
    } catch (error) {
      console.error('FETCH_APPRAISAL_REVIEW_PROCESS', error)
    }
  },
  async [actionTypes.FETCH_APPRAISAL_STANDARDS]({ commit }) {
    commit(mutationTypes.SET_FETCHING_APPRAISAL_STANDARDS, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_APPRAISAL_STANDARDS,
      })
      if (data && data.appraisalStandards && Array.isArray(data.appraisalStandards)) {
        const appraisalStandards = data.appraisalStandards.map((appraisal) => {
          const appraisalId = kebabCase(appraisal.name)
          return {
            ...appraisal,
            id: appraisalId,
            media: getAppraisalStandardsImage(appraisal.name),
            shortName: appraisal.name,
          }
        })
        commit(mutationTypes.SET_LIST_APPRAISAL_STANDARDS, appraisalStandards)
        commit(mutationTypes.SET_FETCHING_APPRAISAL_STANDARDS, false)
        commit(mutationTypes.SET_FETCH_ERROR_APPRAISAL_STANDARDS, false)
        return
      }
      throw data
    } catch (error) {
      console.error('FETCH_APPRAISAL_STANDARDS', error)
      commit(mutationTypes.SET_FETCHING_APPRAISAL_STANDARDS, false)
      commit(mutationTypes.SET_FETCH_ERROR_APPRAISAL_STANDARDS, true)
    }
  },
  async [actionTypes.FETCH_ACTIVATED_FRAMEWORKS]({ commit, rootState }) {
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      const { data } = await apolloClient.query({
        query: GET_ACTIVATED_FRAMEWORKS,
        fetchPolicy: 'network-only',
        variables: { schoolId: rootState.school.schoolProfile.id, statuses: ['ACTIVATED'] },
      })
      if (data && data.appraisalFrameworks) {
        const { data: appraisals } = data.appraisalFrameworks
        commit(mutationTypes.SET_LIST_ACTIVATED_INTERNATIONAL_FRAMEWORKS, appraisals)
      }
    } catch (error) {
      console.error('FETCH_ACTIVATED_FRAMEWORKS', error)
    }
  },
  async [actionTypes.FETCH_APPRAISAL_SUMMARY]({ commit, rootState }, { date, fetchPolicy = 'no-cache' } = {}) {
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      const variables = { schoolId: rootState.school.schoolProfile.id }
      if (date) {
        variables.date = date
      }
      const query = {
        query: GET_APPRAISAL_SUMMARY,
        variables,
      }
      if (fetchPolicy) {
        query.fetchPolicy = fetchPolicy
      }
      const { data } = await apolloClient.query(query)
      if (data.appraisalSummary) {
        commit(mutationTypes.SET_APPRAISAL_SUMMARY, data.appraisalSummary)
      }
    } catch (error) {}
  },
  async [actionTypes.FETCH_APPRAISAL_ASSIGNS](
    { commit, rootState },
    { schoolId, date, personalProfileId, reviewerPersonalProfileId, fetchPolicy = 'no-cache' } = {}
  ) {
    commit(mutationTypes.SET_FETCHING_APPRAISAL_ASSIGNS, true)
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      const variables = {}

      if (date) {
        variables.date = date
      }
      if (schoolId) {
        variables.schoolId = schoolId
      }
      if (personalProfileId) {
        variables.personalProfileId = personalProfileId
      }
      if (reviewerPersonalProfileId) {
        variables.reviewerPersonalProfileId = reviewerPersonalProfileId
      }
      const query = {
        query: GET_SCHOOL_APPRAISAL_RECORDS_ASSIGN,
        variables,
      }
      if (fetchPolicy) {
        query.fetchPolicy = fetchPolicy
      }
      const { data } = await apolloClient.query(query)

      if (data.appraisalAssigns && Array.isArray(data.appraisalAssigns)) {
        commit(mutationTypes.SET_LIST_APPRAISAL_ASSIGNS, data.appraisalAssigns)
        commit(mutationTypes.SET_FETCHING_APPRAISAL_ASSIGNS, false)
        commit(mutationTypes.SET_FETCH_ERROR_APPRAISAL_ASSIGNS, false)
        return
      }
      throw data
    } catch (error) {
      commit(mutationTypes.SET_FETCHING_APPRAISAL_ASSIGNS, false)
      commit(mutationTypes.SET_FETCH_ERROR_APPRAISAL_ASSIGNS, true)
    }
  },
  async [actionTypes.FETCH_APPRAISAL_PERIODS]({ commit, rootState }) {
    try {
      const schoolId = get(rootState, 'school.schoolProfile.id', null)
      if (!schoolId) return
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_APPRAISAL_PERIODS,
        fetchPolicy: 'network-only',
        variables: { schoolId },
      })
      if (data && data.appraisalSchedules) {
        commit(mutationTypes.SET_APPRAISAL_PERIODS, data.appraisalSchedules)
      }
    } catch (error) {
      console.error('FETCH_APPRAISAL_PERIODS', error)
    }
  },
  async [actionTypes.CREATE_NEW_FRAMEWORK]({ commit }, framework) {
    commit(mutationTypes.SET_CREATING_NEW_FRAMEWORK, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: APPRAISAL_CREATE_FRAMEWORK,
        variables: {
          input: framework,
        },
      })
      commit(mutationTypes.SET_CREATING_NEW_FRAMEWORK, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      commit(mutationTypes.SET_CREATING_NEW_FRAMEWORK, false)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.UPDATE_FRAMEWORK]({ commit }, { id, framework }) {
    commit(mutationTypes.SET_UPDATING_FRAMEWORK, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient

      const { data } = await apolloClient.mutate({
        mutation: APPRAISAL_UPDATE_FRAMEWORK,
        variables: {
          input: framework,
          id,
        },
      })
      commit(mutationTypes.SET_UPDATING_FRAMEWORK, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      commit(mutationTypes.SET_UPDATING_FRAMEWORK, false)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.APPRAISAL_DUPLICATE_FRAMEWORK]({ commit }, ids) {
    commit(mutationTypes.SET_DUPLICATING_FRAMEWORK, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: APPRAISAL_DUPLICATE_FRAMEWORK,
        variables: {
          ids,
        },
      })
      commit(mutationTypes.SET_DUPLICATING_FRAMEWORK, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      commit(mutationTypes.SET_DUPLICATING_FRAMEWORK, false)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD]({ commit }, params) {
    commit(mutationTypes.SET_DUPLICATING_FRAMEWORK, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: APPRAISAL_DUPLICATE_FRAMEWORK_STANDARD,
        variables: {
          ...params,
        },
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    } finally {
      commit(mutationTypes.SET_DUPLICATING_FRAMEWORK, false)
    }
  },
  async [actionTypes.FETCH_APPRAISAL_FRAMEWORK_DETAIL]({ commit }, id) {
    if (!id) {
      return
    }
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      commit(mutationTypes.SET_FETCHING_APPRAISAL_FRAMEWORK_DETAIL, true)
      const { data } = await apolloClient.query({
        query: GET_APPRAISAL_FRAMEWORK_DETAIL,
        fetchPolicy: 'network-only',
        variables: {
          id: parseInt(id),
        },
      })
      if (data && data.appraisalFramework) {
        commit(mutationTypes.SET_APPRAISAL_FRAMEWORK_DETAIL, data.appraisalFramework)
      }
    } catch (error) {
      console.error('FETCH_APPRAISAL_FRAMEWORK_DETAIL', error)
    } finally {
      commit(mutationTypes.SET_FETCHING_APPRAISAL_FRAMEWORK_DETAIL, false)
    }
  },
  async [actionTypes.FETCH_REVIEW_PROCESS_ACTIVITIES]({ getters, commit }, { schoolId, page, limit }) {
    commit(mutationTypes.SET_REVIEW_PROCESS_ACTIVITIES, { ...getters.reviewProcessActivities, loading: true })
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      const { data } = await apolloClient.query({
        query: GET_USER_ACTIVITY_HISTORIES,
        fetchPolicy: 'network-only',
        variables: {
          targetType: USER_ACTIVITY_TARGET_TYPE.REVIEW_PROCESS,
          schoolId,
          page,
          limit,
        },
      })
      if (data && data.userActivityHistories) {
        commit(mutationTypes.SET_REVIEW_PROCESS_ACTIVITIES, data.userActivityHistories)
      }
    } catch (error) {
      console.error('FETCH_REVIEW_PROCESS_ACTIVITIES', error)
    } finally {
      commit(mutationTypes.SET_REVIEW_PROCESS_ACTIVITIES, { ...getters.reviewProcessActivities, loading: false })
    }
  },
  async [actionTypes.CHECK_IS_PERFORMANCE_V2]({ commit, rootGetters }, params) {
    const apolloClient = this.app.apolloProvider.defaultClient
    try {
      const data = (await getListFrameworksV2(apolloClient, params)).data
      commit(mutationTypes.SET_IS_PERFORMANCE_V2, !!data.length)
    } catch (error) {
      console.error('CHECK_IS_PERFORMANCE_V2', error)
    } finally {
      commit(mutationTypes.SET_REVIEW_PROCESS_ACTIVITIES, { ...getters.reviewProcessActivities, loading: false })
    }
  },
}

export const getters = {
  appraisalStandards: (state) => state.appraisalStandards,
  appraisalPeriods: (state) => state.appraisalPeriods,
  schoolAppraisalAssigns: (state) => state.schoolAppraisalAssigns,
  appraisalFrameworks: (state) => state.appraisalFrameworks,
  activatedInternationalFrameworks: (state) => state.activatedInternationalFrameworks,
  appraisalAudits: (state) => state.appraisalAudits,
  viewingMode: (state) => state.viewingMode,
  frameworkInFocus: (state) => state.frameworkInFocus,
  fetchingFrameworkDetail: (state) => state.fetchFrameworkDetail.inProgress,
  reviewProcessSettings: (state) => state.reviewProcessSettings,
  changesToFinalised: (state) => state.reviewProcessSettings?.changesToFinalised,
  reviewProcessActivities: (state) => state.reviewProcessActivities,
  isPerformanceV2: (state) => state.isPerformanceV2,
}
